// extracted by mini-css-extract-plugin
export default {"container":"thesun_container__aaprV"};